import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-weave-textarea-flat',
    templateUrl: './weave-textarea-flat.component.html',
    styleUrls: ['./weave-textarea-flat.component.scss'],
    standalone: false
})
export class WeaveTextareaFlatComponent implements OnInit {
  @Input() data: string;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Input() maxlength: number = 524288;
  @Input() rows: number = -1;
  @Input() disabledFlag: boolean = true;
  @Input() required: boolean = false;
  @Input() showError: boolean = false;
  @Input() hasAutoHeight: boolean = true;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() KeyUp: EventEmitter<string> = new EventEmitter<string>();
  tempValue: any;
  id: string = "";

  constructor() {
  }

  ngOnInit() {
    this.id = "weave-textarea" + Math.floor(Math.random() * 1000);
  }

  onFocusOut() {
    this.focusOut.emit(this.data);
  }
  onKeyUp(event) {
    this.KeyUp.emit(this.data);
  }

  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.showError = false;
    this.data = this.tempValue;
  }
}
